import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=3aa0fa46&scoped=true&"
import script from "./Persona.vue?vue&type=script&lang=ts&"
export * from "./Persona.vue?vue&type=script&lang=ts&"
import style0 from "./Persona.vue?vue&type=style&index=0&id=3aa0fa46&scoped=true&lang=less&"
import style1 from "./Persona.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0fa46",
  null
  
)

export default component.exports